import { useState, type FormEvent } from "react";
import { useNavigate } from "react-router";
import { useApiResource } from "@/hooks/useApiResource";
import { useAsyncAction } from "@/hooks/useAsyncAction";
import { api, type InvitacionInfo, type Usuario } from "@/lib/api";
import { MENSAJE_INVITACION_INVALIDA, validarPasswordNueva } from "@/lib/usuarios";

/** Lógica de la pantalla pública para elegir la contraseña desde un link de invitación (sin JSX). */
export function useInvitacionTab(token: string, onIngreso: (u: Usuario) => void) {
  const ruta = `/api/invitaciones/${encodeURIComponent(token)}`;
  const info = useApiResource<InvitacionInfo>(ruta);
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [repetida, setRepetida] = useState("");
  const [intentado, setIntentado] = useState(false);
  const accion = useAsyncAction((p: string) => api.post<Usuario>(ruta, { password: p }));
  const errorValidacion = validarPasswordNueva(password, repetida);

  const enviar = async (e: FormEvent) => {
    e.preventDefault();
    setIntentado(true);
    if (errorValidacion) return;
    const usuario = await accion.run(password);
    if (usuario) {
      onIngreso(usuario);
      navigate("/", { replace: true });
    }
  };

  const errorCarga = info.error ? (info.error.status === 404 ? MENSAJE_INVITACION_INVALIDA : info.error.message) : null;

  return {
    cargando: info.loading,
    errorCarga,
    nombre: info.data?.nombre ?? "",
    email: info.data?.email ?? "",
    password,
    setPassword,
    repetida,
    setRepetida,
    error: (intentado ? errorValidacion : null) ?? accion.error,
    enviar,
    guardando: accion.loading,
  };
}
